import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { LocalStorageService } from "angular-2-local-storage";
import { environment } from "../../../../environments/environment";
import { Observable } from "rxjs";
import { BuilkUserDataModel } from "../../../model/builk/builk-auth/builk-user-data.model";

@Injectable({
    providedIn: "root"
})

export class BuilkAuthService {
    constructor(
        private http: HttpClient,
        private localStorageService: LocalStorageService
    ) { }

    sub: any;

    getUserData(): Observable<BuilkUserDataModel> {
        const params = new HttpParams().set("email", String(this.localStorageService.get<string>("userEmail")));
        const url = `${environment.apiBuilkURL}api/V1/Authorization/GetUserData`;
        this.sub = this.http.get<BuilkUserDataModel>(url, { params });

        return this.sub;
    }
}
